<div id="modified-payee-container" class="modified-payee-container">
  <div class="row">
    <mm-text-input-control data-testid="modPayeeName1" [parentForm]="parentForm" [inputControlModel]="payeeName1Model"
      [errorMessage]="payeeNameError">
    </mm-text-input-control>
    <mm-text-input-control data-testid="modPayeeName2" *ngIf="showModPayeeTwo" [parentForm]="parentForm" [inputControlModel]="payeeName2Model"
      [errorMessage]="payeeNameError" class="modPayeeName">
    </mm-text-input-control>
    <mm-text-input-control data-testid="modPayeeName3" *ngIf="showModPayeeThree" [parentForm]="parentForm" [inputControlModel]="payeeName3Model"
      [errorMessage]="payeeNameError" class="modPayeeName">
    </mm-text-input-control>
  </div>
</div>
